module.exports = __webpack_public_path__ + "assets/img/list.76dedeca.svg";